export default function SearchIcon({
  width,
  height,
}: {
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width ? width : "13"}
      height={height ? height : "13"}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.77194 8.06L13 11.3344L11.375 13L8.06406 9.7695C7.22899 10.2892 6.2648 10.5639 5.28125 10.5625C2.36438 10.5625 0 8.19244 0 5.28125C0 2.36438 2.37006 0 5.28125 0C8.19812 0 10.5625 2.37006 10.5625 5.28125C10.564 6.2632 10.2901 7.22588 9.77194 8.06ZM1.62256 5.24225C1.62256 7.25725 3.25894 8.8985 5.27881 8.8985C7.29381 8.8985 8.93506 7.26131 8.93506 5.24225C8.93506 3.22725 7.29787 1.586 5.27881 1.586C3.26381 1.586 1.62256 3.22238 1.62256 5.24225Z"
        fill="currentColor"
      />
    </svg>
  );
}
